/* eslint-disable @wordpress/dependency-group */
console.log( 'Hello from the theme index.js file!' );

import './inc/mobile-menu';

document.querySelectorAll( '*' ).forEach( ( el ) => {
	if ( el.offsetWidth > document.documentElement.offsetWidth ) {
		console.log( 'OVERFLOW ----- Found the worst element ever: ', el );
	}
} );
